import { motion } from 'framer-motion';

const milestones = [
  {
    period: '2019 to 2023',
    title: 'Early Beginnings',
    detail: 'Originally, I planned to become a mechanical engineer, which is how I ended up in VEX Robotics. I quickly realized that coding was my favorite part of every project. I got to build introductory projects like RC cars, line-tracking robots, and maze solvers.',
  },
  {
    period: '2022 to 2024',
    title: 'Introduction to (REAL) Engineering',
    detail: 'Intro to Computing and Embedded Systems made me realize how abstracted my earlier work had been. Our first programming assignment was in binary, which was intimidating at first, to be fair, but it was a great introduction to how computers actually work. Later, in Embedded Systems, we built games from scratch: designing the PCB, soldering it together, and coding a football game in C.',
  },
  {
    period: 'Summer 2025',
    title: 'My First Internship',
    detail: 'My first internship at Capital One put me on the credit line increase team. I built a model to predict outstanding balances on customers’ credit cards, which supported account- and segment-level risk monitoring.',
  },
  {
    period: 'Summer 2026',
    title: 'Coming Back!',
    detail: 'When I came back to Capital One, I joined the underwriting team for Auto Finance. I got to lead my own project exploring new credit datasets and determining whether they added enough value to include in our models.',
  },
];

export default function StorySection() {
  return (
    <section id="story" className="section story" aria-labelledby="story-heading">
      <div className="container">
        <p className="eyebrow">My story</p>
        <h2 id="story-heading" className="section-heading">My whole journey!</h2>
        <p className="section-intro">Every step has led me to where I am today.</p>

        <div className="story-timeline">
          {milestones.map((milestone, index) => (
            <motion.article className={`story-item story-item--${index % 2 === 0 ? 'left' : 'right'}`} key={milestone.period} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.35 }}>
              <div className="story-item__node" aria-hidden="true"><span /></div>
              <div className="story-item__content">
                <p className="story-item__period">{milestone.period}</p>
                <h3>{milestone.title}</h3>
                <p>{milestone.detail}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
